import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import { parse, format, isValid } from 'date-fns';
import 'react-datepicker/dist/react-datepicker.css';

const DateField = ({
  label,
  id,
  value,
  onChange,
  required = false,
  minDate,
  maxDate,
  error,
  extra,
  allowKeyboardInput = false,
  state,
  disabled,
}) => {
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    setInputValue(value || '');
  }, [value]);

  const handleManualInput = (e) => {
    let newValue = e.target.value.replace(/\D/g, '');

    if (newValue.length <= 8) {
      if (newValue.length >= 2) {
        newValue = newValue.slice(0, 2) + '/' + newValue.slice(2);
      }
      if (newValue.length >= 5) {
        newValue = newValue.slice(0, 5) + '/' + newValue.slice(5);
      }

      setInputValue(newValue);

      if (newValue.length === 10) {
        const parsedDate = parse(newValue, 'dd/MM/yyyy', new Date());
        if (isValid(parsedDate)) {
          onChange({
            target: {
              id,
              value: format(parsedDate, 'dd/MM/yyyy'),
            },
          });
        }
      }
    }
  };

  return (
    <div className={`flex flex-col ${extra}`}>
      {/* Label */}
      <label
        htmlFor={id}
        className="ml-2 mt-1 text-sm font-bold text-navy-700 dark:text-white"
      >
        {label}
        {required && <span className="ml-1 text-red-500">*</span>}
      </label>

      <DatePicker
        id={id}
        selected={value ? parse(value, 'dd/MM/yyyy', new Date()) : null}
        onChange={(date) => {
          const formattedDate = date ? format(date, 'dd/MM/yyyy') : '';
          onChange({
            target: {
              id,
              value: formattedDate,
            },
          });
          setInputValue(formattedDate);
        }}
        dateFormat="dd/MM/yyyy"
        placeholderText="DD/MM/YYYY"
        minDate={minDate}
        maxDate={maxDate}
        disabled={disabled}
        showYearDropdown
        scrollableYearDropdown
        yearDropdownItemNumber={50}
        className={`mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none 
          ${
            disabled
              ? '!border-none !bg-gray-100 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]'
              : state === 'error'
              ? 'border-red-500 text-red-500 placeholder:text-red-500 dark:!border-red-400 dark:!text-red-400 dark:placeholder:!text-red-400'
              : state === 'success'
              ? 'border-green-500 text-green-500 placeholder:text-green-500 dark:!border-green-400 dark:!text-green-400 dark:placeholder:!text-green-400'
              : 'border-gray-200 dark:!border-white/10 dark:text-white'
          } 
          dark:placeholder:text-white/50`}
        onKeyDown={(e) => {
          if (!allowKeyboardInput) {
            e.preventDefault();
          }
        }}
        value={inputValue}
        onChangeRaw={(e) => {
          if (allowKeyboardInput) {
            handleManualInput(e);
          }
        }}
        autoComplete="off"
      />

      {/* Error Message */}
      {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
    </div>
  );
};

export default DateField;
